import { useContext } from "react";
import { CartContext } from "../../context/CartContext";

const CartItem = ({ id, name, img, price, quantity }) => {
  const { addItem, removeItem } = useContext(CartContext);

  const handleQuantityChange = (newQuantity) => {
    if (newQuantity >= 1) {
      addItem({ id, name, price, img }, newQuantity - quantity);
    } else {
      removeItem(id);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between hover:bg-gray-50 p-4 sm:p-5 transition">
      
      {/* 🖼️ Imagen + Nombre */}
      <div className="flex items-center w-full sm:w-2/5 mb-3 sm:mb-0">
        <div className="w-16 sm:w-20 flex-shrink-0">
          <img
            className="w-full h-full object-cover rounded-md"
            src={img}
            alt={name}
          />
        </div>
        <div className="ml-3 flex flex-col justify-center">
          <span className="font-semibold text-sm sm:text-base">{name}</span>
          <button
            className="rounded-full text-xs sm:text-sm border border-gray-300 mt-1 px-2 py-1 font-medium text-gray-700 transition hover:bg-black hover:text-white"
            onClick={() => removeItem(id)}
          >
            Eliminar
          </button>
        </div>
      </div>

      {/* 🔢 Cantidad */}
      <div className="flex justify-center items-center w-full sm:w-1/5 mb-2 sm:mb-0">
        <button
          onClick={() => handleQuantityChange(quantity - 1)}
          className="p-1 sm:p-2"
        >
          <svg
            className="fill-current text-gray-600 w-3 sm:w-4"
            viewBox="0 0 448 512"
          >
            <path d="M416 208H32c-17.67 0-32 14.33-32 
              32v32c0 17.67 14.33 32 32 32h384
              c17.67 0 32-14.33 32-32v-32
              c0-17.67-14.33-32-32-32z" />
          </svg>
        </button>

        <input
          className="mx-2 border text-center w-10 sm:w-12 text-sm rounded"
          type="text"
          value={quantity}
          readOnly
        />

        <button
          onClick={() => handleQuantityChange(quantity + 1)}
          className="p-1 sm:p-2"
        >
          <svg
            className="fill-current text-gray-600 w-3 sm:w-4"
            viewBox="0 0 448 512"
          >
            <path d="M416 208H272V64c0-17.67-14.33-32
              -32-32h-32c-17.67 0-32 14.33-32
              32v144H32c-17.67 0-32 14.33-32
              32v32c0 17.67 14.33 32 32 32h144v144
              c0 17.67 14.33 32 32 32h32c17.67
              0 32-14.33 32-32V304h144c17.67
              0 32-14.33 32-32v-32c0-17.67
              -14.33-32-32-32z" />
          </svg>
        </button>
      </div>

      {/* 💰 Precio unitario + Total */}
      <div className="flex justify-between sm:justify-center w-full sm:w-2/5 text-sm sm:text-base font-semibold">
        <span className="text-gray-800 sm:text-center">{price} $</span>
        <span className="text-gray-800 sm:text-center">{price * quantity} $</span>
      </div>
    </div>
  );
};

export default CartItem;
